<template>
  <div :class="headerClass">
    <div
      class="c-population-tab-list-header__first-col flex items-center gap-8 px-12"
    >
      <BittsCheckbox
        v-if="canEdit"
        class="mr-8"
        :checked="allItemsSelected"
        :indeterminate="someItemsSelected"
        @input="emit('select-all', $event)"
      />
      <span class="text-sm font-bold text-neutral-text">
        {{ firstColumnLabel }}
      </span>
    </div>
    <div
      class="flex items-center gap-4 px-12"
      v-for="field in headerFields"
      :key="field.label"
    >
      <p class="text-sm font-bold text-neutral-text">
        {{ field.label }}
      </p>
      <component :is="field.tooltip ? BittsTooltip : 'div'" placement="top">
        <FontAwesomeIcon
          v-if="field.tooltip"
          :icon="['fak', 'information-circle']"
          :style="{
            height: '12px',
            width: '12px',
            color: 'currentColor',
          }"
          class="text-neutral-accent flex items-center justify-center"
        />
        <template v-if="field.tooltip" #title>
          {{ field.tooltip }}
        </template>
      </component>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsCheckbox, BittsTooltip } from '@crossbeam/bitts';

type HeaderField = {
  label: string;
  tooltip?: string;
};

type Props = {
  firstColumnLabel: string;
  headerFields: HeaderField[];
  allItemsSelected: boolean;
  someItemsSelected: boolean;
  headerClass?: string;
  canEdit?: boolean;
};

withDefaults(defineProps<Props>(), {
  headerClass:
    'border-b border-neutral-border rounded-tr-16 rounded-tl-16 px-4 py-8 w-full grid gap-4 items-center',
  canEdit: true,
});

const emit = defineEmits<{
  'select-all': [checked: boolean];
}>();
</script>
